import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { CourseList } from 'views/online-trainings/course-list';

export const OnlineTrainings = () => {
    const { t } = useTranslation('', { keyPrefix: 'SEO.onlineTrainings' });

    return (
        <>
            <CustomHeader title={t('title')} />
            <CourseList />
        </>
    );
};
